module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5",
    attrs: {
      "id": "summary-tab"
    }
  }, [(_vm.selectedOption === 'tab_class_wide') ? _c('div', {
    staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-10 my-8",
    class: !_vm.hasTeacherPermissionsInCourse ? 'mt-7' : ''
  }, [_c('div', {
    attrs: {
      "id": "responses-chart"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('h5', {
    staticClass: "title mb-1"
  }, [_vm._v("Responses")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:percentages-info.left",
      arg: "percentages-info",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "mr-2 ml-4"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:percentages-questions.left",
      arg: "percentages-questions",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "mr-2"
  }, [_c('i', {
    staticClass: "fas fa-question-circle"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "about mb-4"
  }, [_vm._v("\n        Participation data about student responses and comments in the\n        discussion.\n      ")]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "percentages-info",
      "width": 600
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v("Information")])]), _vm._v(" "), _c('div', {
    staticClass: "border-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "px-6 py-4"
  }, [_c('p', [_vm._v("\n            These statistics are helpful to gather a birds-eye view of student\n            engagement.\n          ")])])]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-20",
    attrs: {
      "name": "percentages-questions",
      "width": 600
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v("Reflection Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "border-b"
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-decimal list-inside px-6 py-4"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n            What do these percentages tell us about our discussion?\n          ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n            Is it important for everyone to comment? Why or why not?\n          ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n            Is it important for everyone to receive feedback? Why or why not?\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            How might we improve these numbers in future Written Roundtables?\n          ")])])]), _vm._v(" "), (_vm.isLoadingResponses === false) ? _c('div', [_c('ProgressiveBar', {
    staticClass: "mb-4",
    attrs: {
      "percentage": Math.round(_vm.participationRate()),
      "textAbout": 'submitted a response',
      "height": 12
    }
  }), _vm._v(" "), _c('ProgressiveBar', {
    staticClass: "mb-4",
    attrs: {
      "percentage": Math.round(_vm.summaryDetails.studentsWhoMadeAtLeastOneComment),
      "textAbout": 'gave at least one comment',
      "height": 12
    }
  }), _vm._v(" "), _c('ProgressiveBar', {
    staticClass: "mb-4",
    attrs: {
      "percentage": Math.round(_vm.summaryDetails.studentsWhoReceivedAtLeastOneComment),
      "textAbout": 'received at least one comment',
      "height": 12
    }
  })], 1) : _c('div', [_vm._m(0)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "average-comment"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('h5', {
    staticClass: "title mb-1"
  }, [_vm._v("Average Comment Length")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:comment-length-info.left",
      arg: "comment-length-info",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "mr-2 ml-4"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:comment-length-questions.left",
      arg: "comment-length-questions",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "mr-2"
  }, [_c('i', {
    staticClass: "fas fa-question-circle"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "about mb-4"
  }, [_vm._v("\n        The average length (in words) of each student comment in the\n        RoundTable.\n      ")]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "comment-length-info",
      "width": 600
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v("Information")])]), _vm._v(" "), _c('div', {
    staticClass: "border-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "px-6 py-4"
  }, [_c('p', [_vm._v("\n            A typical sentence is about 15 words long. Our hope is that\n            students provide at least two sentences when giving feedback to\n            their peers.\n          ")])])]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-20",
    attrs: {
      "name": "comment-length-questions",
      "width": 600
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v("Reflection Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "border-b"
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-decimal list-inside px-6 py-4"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n            Why does the average word length of our peer comments/feedback\n            matter?\n          ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n            Does the number of words in a comment reflect the quality of the\n            comment?\n          ")]), _vm._v(" "), _c('li', [_vm._v("How can we improve in our next Written RoundTable?")])])]), _vm._v(" "), (_vm.isLoadingResponses === false) ? _c('div', [_c('AverageProgress', {
    staticClass: "mt-10",
    attrs: {
      "totalWords": Math.round(_vm.summaryDetails.averageCommentLength)
    }
  })], 1) : _c('div', [_vm._m(1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "keywordCloud"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Keyword Cloud")]), _vm._v(" "), _c('button', {
    staticClass: "ml-3 text-lg text-pinky flex items-center"
  }, [_c('i', {
    staticClass: "fa-solid fa-language"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-sm font-semibold ml-2"
  }, [_vm._v(_vm._s(_vm.cloudWordLanguage))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [(_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "px-4 py-2 ml-3 text-xs font-semibold text-gray-600 bg-coolGray-100 hover:bg-coolGray-200 rounded",
    on: {
      "click": function($event) {
        _vm.isEditWordCloudOpen = true
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-pen-to-square mr-1.5"
  }), _vm._v("Edit Words\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:word-cloud-info",
      arg: "word-cloud-info"
    }],
    staticClass: "mr-2 ml-4"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:word-cloud-questions",
      arg: "word-cloud-questions"
    }],
    staticClass: "mr-2"
  }, [_c('i', {
    staticClass: "fas fa-question-circle"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "about mb-4"
  }, [_vm._v("\n        A keyword cloud for the most recurring words across all student\n        responses.\n      ")]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-auto",
    attrs: {
      "name": "word-cloud-info",
      "width": 600
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v("Information")])]), _vm._v(" "), _c('div', {
    staticClass: "border-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold text-gray-900 mb-1"
  }, [_vm._v("\n            The Idea Cloud analyzes the RoundTable for frequent words across\n            student submissions.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "font-normal text-gray-500 mb-3"
  }, [_vm._v("\n            The bigger the word in the cloud, the more times it was used!\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "font-normal text-gray-900 mb-3"
  }, [_vm._v("\n            Share this visual and become a\n            "), _c('span', {
    staticClass: "hover:underline cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.toBlogPost()
      }
    }
  }, [_vm._v("Parlay Trailblazer!")])]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "flex items-center"
  }, [_c('button', {
    staticClass: "bg-blue-500 text-white px-4 py-1 rounded mr-3",
    on: {
      "click": function($event) {
        return _vm.shareOnFB()
      }
    }
  }, [_vm._v("\n              Share "), _c('i', {
    staticClass: "ml-1 fa-brands fa-facebook"
  })]), _vm._v(" "), _c('button', {
    staticClass: "bg-lightBlue-300 text-white px-4 py-1 rounded",
    on: {
      "click": function($event) {
        return _vm.shareOnTW()
      }
    }
  }, [_vm._v("\n              Tweet "), _c('i', {
    staticClass: "fa-brands fa-twitter"
  })])]) : _vm._e()])]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-20",
    attrs: {
      "name": "word-cloud-questions",
      "width": 600
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v("Reflection Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "border-b"
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-decimal list-inside px-6 py-4"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n            What words stood out? Did any surprise you? Why or why not?\n          ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n            Were there any words you thought would be more prominent but were\n            not?\n          ")]), _vm._v(" "), _c('li', [_vm._v("What themes or perspectives stick out in this word cloud?")])])]), _vm._v(" "), (_vm.isLoadingResponses === false) ? _c('div', [_c('WordCloud', {
    on: {
      "cloudLanguague": function (language) { return (_vm.cloudWordLanguage = language); }
    }
  })], 1) : _c('div', [_vm._m(2)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "commentChord"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('h5', {
    staticClass: "title mb-1"
  }, [_vm._v("Comment Chord")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:comment-chord-info.left",
      arg: "comment-chord-info",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "mr-2 ml-4"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:comment-chord-questions.left",
      arg: "comment-chord-questions",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "mr-2"
  }, [_c('i', {
    staticClass: "fas fa-question-circle"
  })]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute",
    staticStyle: {
      "z-index": "10"
    },
    attrs: {
      "name": "comment-chord-info",
      "width": 600
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v("Information")])]), _vm._v(" "), _c('div', {
    staticClass: "border-b"
  }), _vm._v(" "), _c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold text-gray-900 mb-1"
  }, [_vm._v("\n                The Comment Chord shows how many comments and replies each\n                student submitted.\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "font-normal text-gray-500 mb-3"
  }, [_vm._v("\n                Hover over to show the relationship between two students!\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "font-normal text-gray-900 mb-3"
  }, [_vm._v("\n                Share this visual and become a\n                "), _c('span', {
    staticClass: "hover:underline cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.toBlogPost()
      }
    }
  }, [_vm._v("Parlay Trailblazer!")])]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "flex items-center mb-4"
  }, [_c('button', {
    staticClass: "bg-blue-500 text-white px-4 py-1 rounded mr-3",
    on: {
      "click": function($event) {
        return _vm.shareOnFB()
      }
    }
  }, [_vm._v("\n                  Share "), _c('i', {
    staticClass: "ml-1 fa-brands fa-facebook"
  })]), _vm._v(" "), _c('button', {
    staticClass: "bg-lightBlue-300 text-white px-4 py-1 rounded",
    on: {
      "click": function($event) {
        return _vm.shareOnTW()
      }
    }
  }, [_vm._v("\n                  Tweet "), _c('i', {
    staticClass: "fa-brands fa-twitter"
  })])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-gray-500 text-xs"
  }, [_vm._v("\n                Students' names will not be visible in the public version of\n                the graph*\n              ")])])]), _vm._v(" "), _c('popover', {
    staticClass: "mr-10 p-0 bg-white drop-shadow absolute z-20",
    attrs: {
      "name": "comment-chord-questions",
      "width": 650
    }
  }, [_c('div', {
    staticClass: "px-6 py-4"
  }, [_c('h5', {
    staticClass: "font-semibold"
  }, [_vm._v("Reflection Questions")])]), _vm._v(" "), _c('div', {
    staticClass: "border-b"
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-decimal list-inside px-6 py-4"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n                Was this a balanced conversation or did a few voices dominate?\n              ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n                Were there many students who didn't provide any comments or\n                replies?\n              ")]), _vm._v(" "), _c('li', [_vm._v("\n                Overall, did we respond to many comments or replies to develop\n                the conversation or was there a lot of one way communication?\n              ")])])])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "about mb-4"
  }, [_vm._v("\n        A summary of the comments and replies between students.\n      ")]), _vm._v(" "), _c('CommentChord')], 1)]) : _vm._e(), _vm._v(" "), (_vm.isExportModalOpen === true) ? _c('ExportEngagementDataModal', {
    attrs: {
      "fileName": _vm.exportableFileName,
      "getFile": _vm.fetchClassCSVdata,
      "showButtons": Boolean(_vm.getCurrentRT.submissions.length)
    },
    on: {
      "close": function($event) {
        _vm.isExportModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEditWordCloudOpen) ? _c('EditWordCloud', {
    on: {
      "close": function($event) {
        _vm.isEditWordCloudOpen = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animate-pulse"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/5 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/12 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/6 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animate-pulse"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/5 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/12 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/6 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animate-pulse"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/5 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/12 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "w-1/6 h-3 bg-gray-200 dark:bg-gray-700 mb-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5ef29dfb!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/tabs/summaryTab.vue
// module id = 1165
// module chunks = 61